<template>
  <el-dialog
    class="teacher-dialog"
    :visible.sync="dialogVisible"
    width="545px"
    :before-close="handleClose"
    @close="handleClose">

    <!-- 表单 -->
    <div class="form-container">
      <el-form ref="ruleForm" :model="form" :rules="rules" label-width="100px" label-position="top">
        <el-form-item label="联系人姓名：" prop="name">
          <el-input
            v-model="form.name"
            placeholder="请填写您的姓名"
            maxLength="50">
          </el-input>
        </el-form-item>
        <el-form-item label="联系人手机号：" prop="phone">
          <el-input
            v-model="form.phone"
            placeholder="请填写您的手机号"
            maxLength="50">
          </el-input>
        </el-form-item>
        <el-form-item label="单位名称：" prop="unitName">
          <el-input
            v-model="form.unitName"
            placeholder="请填写您的企业名称"
            maxLength="50">
          </el-input>
        </el-form-item>
        <el-form-item label="需求描述：" prop="content">
          <el-input
            v-model="form.content"
            type="textarea"
            placeholder="请填写您的合作意向"
            maxLength="500">
          </el-input>
        </el-form-item>
        <el-form-item label="邮箱：" prop="email">
          <el-input
            v-model="form.email"
            placeholder="请填写您的邮箱"
            maxLength="50">
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button class="submit" @click="onSubmit('ruleForm')">立 即 合 作</el-button>
        </el-form-item>
      </el-form>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      form: {
        name: '',
        phone: '',
        unitName: '',
        content: '',
        email: ''
      },
      rules: {
        name: [
          { required: true, message: '联系人姓名不能为空', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '联系人手机号不能为空', trigger: 'blur' }
        ],
        unitName: [
          { required: true, message: '单位名称不能为空', trigger: 'blur' }
        ],
        content: [
          { required: true, message: '需求描述不能为空', trigger: 'blur' }
        ],
        email: [
          { required: true, message: '邮箱不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    // 关闭弹窗
    handleClose() {
      this.$emit('close')
    },
    // 提交表单/是否预览
    onSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$emit('submit', this.form)
          console.log('submit!')
        } else {
          console.log('error submit!!')
          return false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .teacher-dialog {
    overflow: hidden;
    ::v-deep .el-dialog {
      margin-top: 10vh !important;
      .el-dialog__header {
        height: 145px;
        background-image: url("../../../assets/image/more-banner.png");
        background-size: 100% 100%;
        background-repeat: no-repeat;
        .el-dialog__headerbtn {
          top: -20px;
          right: -36px;
          i {
            color: #fff;
            font-size: 28px;
            font-weight: bold;
          }
        }
      }
      .el-dialog__body {
        max-height: 350px;
        overflow-y: scroll;
        padding: 40px 30px;
      }
      .el-form {
        .el-form-item {
          margin-bottom: 25px;
          .el-form-item__error {
            margin: 5px 0;
          }
          .el-form-item__label {
            color: #333;
            font-size: 14px;
            font-weight: bold;
          }
          .el-input {
            width: 100%;
            height: 45px;
          }
          .el-input__inner, .el-textarea__inner {
            height: 45px;
            color: #666;
            font-weight: bold;
            font-size: 12px;
          }
          .el-textarea__inner {
            height: 100px;
          }
        }
        .submit {
          width: 100%;
          height: 55px;
          font-size: 16px;
          color: #fff;
          font-weight: bold;
          background: linear-gradient(90deg, #0F59BE 0%, #4A6EEF 100%);
          border-radius: 50px;
          margin-top: 50px;
        }
      }
      .el-dialog__footer {
        width: 100%;
        border-top: 1px solid #ddd;
        padding-top: 15px;
      }
    }
  }
</style>
